var _path, _path2, _circle, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgListenActive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 91,
    height: 42,
    viewBox: "0 0 91 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M90 41.5H90.5V41V25C90.5 11.469 79.531 0.5 66 0.5H21C9.67816 0.5 0.5 9.67816 0.5 21C0.5 32.3218 9.67816 41.5 21 41.5H90Z",
    fill: "url(#paint0_linear_1494_506)",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44.386 28V14.998H45.75V27.01H49.38V28H44.386ZM50.6973 28V17.11H52.0393V28H50.6973ZM51.3793 15.768C51.1593 15.768 50.9686 15.6947 50.8073 15.548C50.6606 15.3867 50.5873 15.2033 50.5873 14.998C50.5873 14.778 50.6606 14.602 50.8073 14.47C50.9686 14.3233 51.1593 14.25 51.3793 14.25C51.5846 14.25 51.7679 14.3233 51.9293 14.47C52.0906 14.602 52.1713 14.778 52.1713 14.998C52.1713 15.2033 52.0906 15.3867 51.9293 15.548C51.7679 15.6947 51.5846 15.768 51.3793 15.768ZM57.0111 28.154C56.2191 28.154 55.6031 28.0587 55.1631 27.868C54.7231 27.6627 54.4151 27.3473 54.2391 26.922C54.0631 26.482 53.9751 25.9027 53.9751 25.184V24.238H55.3611V25.492C55.3611 26.1813 55.4784 26.658 55.7131 26.922C55.9477 27.186 56.3731 27.318 56.9891 27.318C57.5317 27.318 57.9277 27.186 58.1771 26.922C58.4411 26.658 58.5731 26.2107 58.5731 25.58V24.964C58.5731 24.6267 58.5217 24.3407 58.4191 24.106C58.3164 23.8567 58.1184 23.6293 57.8251 23.424C57.5464 23.2187 57.1504 23.0133 56.6371 22.808C56.1531 22.6173 55.7277 22.412 55.3611 22.192C54.9944 21.972 54.7011 21.6933 54.4811 21.356C54.2757 21.0187 54.1731 20.586 54.1731 20.058V19.398C54.1731 18.6207 54.3931 18.0193 54.8331 17.594C55.2877 17.154 56.0504 16.934 57.1211 16.934C57.8251 16.934 58.3824 17.0293 58.7931 17.22C59.2184 17.4107 59.5264 17.7187 59.7171 18.144C59.9224 18.5693 60.0251 19.1193 60.0251 19.794V20.718H58.6831V19.662C58.6831 18.9287 58.5584 18.43 58.3091 18.166C58.0597 17.8873 57.6637 17.748 57.1211 17.748C56.5051 17.748 56.0871 17.8947 55.8671 18.188C55.6617 18.4813 55.5591 18.848 55.5591 19.288V19.882C55.5591 20.2927 55.6471 20.63 55.8231 20.894C56.0137 21.158 56.2777 21.378 56.6151 21.554C56.9524 21.73 57.3557 21.9133 57.8251 22.104C58.2504 22.28 58.6244 22.4707 58.9471 22.676C59.2844 22.8667 59.5484 23.1307 59.7391 23.468C59.9297 23.8053 60.0251 24.2673 60.0251 24.854V25.36C60.0251 25.9467 59.9297 26.4527 59.7391 26.878C59.5631 27.2887 59.2551 27.604 58.8151 27.824C58.3751 28.044 57.7737 28.154 57.0111 28.154ZM64.352 28.022C64.0294 28.022 63.736 27.9853 63.472 27.912C63.208 27.8387 62.9807 27.7213 62.79 27.56C62.5994 27.384 62.4527 27.164 62.35 26.9C62.2474 26.6213 62.196 26.2767 62.196 25.866V17.968H61.228V17.264L62.284 17.11L62.526 15.064H63.56V17.11H65.914V17.968H63.56V25.624C63.56 26.0347 63.6334 26.3793 63.78 26.658C63.9267 26.9367 64.2494 27.076 64.748 27.076C64.9534 27.076 65.1734 27.0687 65.408 27.054C65.6427 27.0247 65.8114 27.01 65.914 27.01V27.89C65.7967 27.89 65.5914 27.912 65.298 27.956C65.0047 28 64.6894 28.022 64.352 28.022ZM70.1207 28.198C69.3873 28.198 68.7933 28.1173 68.3387 27.956C67.884 27.78 67.554 27.4647 67.3487 27.01C67.1433 26.5553 67.0407 25.8953 67.0407 25.03V19.596C67.0407 18.5693 67.268 17.8653 67.7227 17.484C68.192 17.1027 68.962 16.912 70.0327 16.912C71.074 16.912 71.822 17.1027 72.2767 17.484C72.746 17.8653 72.9807 18.5693 72.9807 19.596V22.412H68.4047V25.492C68.4047 26.196 68.5147 26.6873 68.7347 26.966C68.9547 27.23 69.402 27.362 70.0767 27.362C70.6927 27.362 71.1033 27.23 71.3087 26.966C71.514 26.702 71.6167 26.2107 71.6167 25.492V24.084H72.9807V25.008C72.9807 25.8587 72.878 26.5187 72.6727 26.988C72.4673 27.4427 72.152 27.758 71.7267 27.934C71.316 28.11 70.7807 28.198 70.1207 28.198ZM68.4047 21.708H71.6167V19.552C71.6167 18.936 71.514 18.4887 71.3087 18.21C71.1033 17.9313 70.678 17.792 70.0327 17.792C69.3873 17.792 68.9547 17.9313 68.7347 18.21C68.5147 18.4887 68.4047 18.936 68.4047 19.552V21.708ZM74.9316 28V17.11H76.0536L76.2296 18.276C76.347 17.836 76.6183 17.4987 77.0436 17.264C77.469 17.0293 77.909 16.912 78.3636 16.912C79.141 16.912 79.7056 17.0513 80.0576 17.33C80.4243 17.594 80.659 17.946 80.7616 18.386C80.8643 18.8113 80.9156 19.2807 80.9156 19.794V28H79.5516V19.992C79.5516 19.728 79.5443 19.4713 79.5296 19.222C79.515 18.9727 79.4563 18.7527 79.3536 18.562C79.2656 18.3567 79.1116 18.1953 78.8916 18.078C78.6716 17.9607 78.349 17.902 77.9236 17.902C77.557 17.902 77.2563 17.9753 77.0216 18.122C76.8016 18.254 76.633 18.4153 76.5156 18.606C76.413 18.782 76.3396 18.9507 76.2956 19.112V28H74.9316Z",
    fill: "white"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 21,
    cy: 21,
    r: 18,
    fill: "url(#paint1_linear_1494_506)",
    stroke: "white",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1494_506)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3298 18.2305C14.3488 18.2502 15.3595 18.4187 16.3298 18.7305",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3298 20C20.7262 20.8787 21.892 22.0788 22.7298 23.5",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeDasharray: "3.31 3.31"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.4299 25C23.7638 25.9396 23.9984 26.9116 24.1299 27.9",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.9299 23.1191C12.9299 23.1191 19.4299 23.1191 20.1299 29.6191",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.23 12.9297C14.23 12.9297 29.53 13.3297 28.72 27.2297",
    stroke: "white",
    strokeWidth: 1.85,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1494_506",
    x1: 24.5,
    y1: 11,
    x2: 85,
    y2: 41,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#147BBD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.42,
    stopColor: "#0C5EB8",
    stopOpacity: 0.79
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0037B1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1494_506",
    x1: 6.5,
    y1: 10.5,
    x2: 27,
    y2: 36.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#17B3E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.485,
    stopColor: "#0D78C5",
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#023AA8"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1494_506"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17.68,
    height: 18.55,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListenActive);
export default __webpack_public_path__ + "static/media/ListenActive.6fda528d04fb0a5bf07af9fc282cc96d.svg";
export { ForwardRef as ReactComponent };